if(window.BOLD && BOLD.options && BOLD.options.app){
  BOLD.options.app.on('options_loaded', function(evt){
    shappify_options_rendered();
  });

  BOLD.options.app.on('price_updated', function(evt){
    //If the money format wasn't wrapped in a span (presumably with class of money), wrap it. Afterwards, make sure the Multicurrency Double-check runs.
    var nowrappers = evt.data.elements;
    for(var w=0; w<nowrappers.length; w++){

      var needswrap = nowrappers[w];
      var content = needswrap.firstChild;
      if(content.nodeType !== Node.TEXT_NODE){
        continue;
      }

      var moneyWrap = document.createElement("span");
      moneyWrap.className = 'money';
      moneyWrap.appendChild(content)


      needswrap.appendChild(moneyWrap)
    }
    BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
  })
}

function shappify_options_rendered(){
  $('.shappify_option_value').find('select').on('change', function() {
      if ( $('#option_total').is(':visible') ) {
        $('.bold-price-poption').html($('#option_display_total_format').find('#formatted_option_total').html());

      }
  });

  var event = new Event('change');
  var all_select_boxes = document.querySelectorAll('.shappify_option_value select');
  for(var i=0; i<all_select_boxes.length; i++){
    all_select_boxes[i].selectedIndex = 1;
    all_select_boxes[i].dispatchEvent(event);
  }

  $.each($('.shappify_option, .bold_option'), function(){
    var option = $(this),
        optionName = option.find('.shappify_option_name, .bold_option_title').text().toLowerCase().replace(/[^a-zA-Z-0-9]/g, '');
    $.each(Shopify.optionTitleObject, function(index, item){
      if(optionName === item.option_title.toLowerCase().replace(/[^a-zA-Z-0-9]/g, '')  && option.find('.fa-question-circle').length == 0){
        option.find('.shappify_option_name, .bold_option_title').append('<a target="_blank" href="'+item.url+'" style="margin-left:5px;"><i class="fa fa-question-circle"></i></a>')
      }
    });
  });

};

(function () {

  function doubleCheckCurrency () {
      BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
  }

  /**
   * Updates the given element with the given price and updates the currency to
   * the selected one
   */
  function updateProductPrice(price, priceElement) {
    priceElement.attr('data-original-value', price).addClass("money");
    priceElement.removeAttr('data-eur');
    priceElement.removeAttr('data-gbp');
    priceElement.removeAttr('data-usd');

    doubleCheckCurrency();
  }

  BOLD.options.app.on('total_changed', function (e) {
    var priceElement = $('.bold-price-poption span');
    var priceHandler = e.data.option_product.priceHandler;
    var price = parseInt($('meta[name="product_price"]').attr('content'));
    updateProductPrice(price + priceHandler.total, priceElement);
  });

})();